<div class="container-fluid">
  <app-report reportId="dashboardReport" screen="Dashboard" [params]="params"></app-report>
</div>
